var OCS = OCS || {};
OCS.UI = OCS.UI || {};
OCS.WxBriefing.Classes = OCS.WxBriefing.Classes || {};
OCS.WxBriefing.Classes.EmbeddableText = new Class({
    Extends: OCS.WxBriefing.Classes.Panel,
    Implements: Options,
    class_name: 'EmbeddableText',
    options: {
        container: null,
        template: 'text_embed',
    },
    render: function () {
        this.populate_panel();
        //this.frame_changed(null, new Date().getTime());
    },
    populate_panel: function () {
        this.parent();
        this.add_content();
        this.load_panel_options();
    },
    add_content_success: function (response) {
        var tm = OCS.WxBriefing.Functions.get_template_manager();
        var content = Elements.from(tm.get_html(this.options.template, {txt: response.text}));
        content.inject(this.options.container);
    },
    add_content: function () {
        var am = OCS.Functions.get_ajax_manager();
        var url = OCS.WxBriefing.Live.UI.replace_url_template_text(this.get_product_content());
        $.get(url, function (data) {
            this.add_content_success({text: data});
        }.bind(this));        
        
//        am.request("fetch_embeddable_text-" + url, {
//            url: url,
//            headers: {
//                'Accept': '*/*'
//            },
//            dataType: "text",
//            type: "GET",
//            storeCompletedReq: 1,
//            urlEncoded: false,
//            onSuccess: this.add_content_success.bind(this),
//            onFailure: function (response) {
//                if (response.failed_attempts < this.options.max_failed_attempts) {
//                    response.request.send();
//                } else {
//                    console.warn("Unable to retrieve product. Giving up after " + response.failed_attempts + " failed attempts.");
//                }
//            }.bind(this)
//        }).send();

    },
    update_product: function () {
        this.unpopulate_panel();
        this.populate_panel();
    }
});